export interface EstimaInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: string | number | undefined;
  checked?: boolean | undefined;
  onChangeInput(value: string | number): void;
  className?: string;
  autoPreFix?: boolean;
  formatCurrency?: boolean;
  error?: boolean;
  type?: string;
  max?: number;
  min?: number;
  maxLength?: number;
  disabled?: boolean;
}
const EstimaInput = ({
  formatCurrency,
  autoPreFix = true,
  value = '',
  checked = undefined,
  onChangeInput,
  className,
  error,
  type,
  max,
  min,
  maxLength,
  disabled,
}: EstimaInputProps) => {
  const classNames = `min-h-[40px] rounded-[3px] px-2 disabled:bg-[#ccc] ${className}
  ${error ? '' : ''}
  ${(type === 'number' || formatCurrency) && 'text-right'}`;

  const regex = /^0\d*$/g;
  const handleChangeInput = (inputValue: string | number) => {
    let dataValue: string | number = inputValue;
    if (type === 'number') {
      dataValue = Number(dataValue);
    }

    if (regex.test(inputValue.toString())) {
      const valueInput = inputValue.toString();
      const valueArray = valueInput.split('');
      valueArray.shift();
      dataValue = Number(valueArray.join(''));
    }
    if (max && max < dataValue) {
      return;
    }

    if (formatCurrency) {
      const valueSplited = dataValue.toString().split(',');
      dataValue = Number(valueSplited.join(''));
      if (maxLength && maxLength < valueSplited.join('').length) return;
    }

    onChangeInput(dataValue);
  };
  const handleCalcValue = () => {
    let newValue: number | string | undefined = value;

    if (type === 'number' && newValue?.toString().length === 1 && autoPreFix) {
      newValue = `0${value}`;
    }

    if (formatCurrency) {
      const currencyNotComma = newValue.toString().split(',');
      newValue = Intl.NumberFormat('en-US').format(Number(currencyNotComma.join(''))) + '';
    }
    if (!newValue) {
      newValue = newValue || '';
    }

    if (!newValue && newValue?.toString() === '0') {
      newValue = 0;
    }

    return newValue;
  };

  return (
    <input
      value={handleCalcValue()}
      className={classNames}
      onChange={(e) => handleChangeInput(e.target.value)}
      max={max}
      min={min}
      disabled={disabled}
      type={type}
      checked={checked}
    />
  );
};

export default EstimaInput;
